/**
 * References for the consent_modes enum table in hasura.
 * @type {Object<string, string>}
 */
export const CONSENT_MODES = {
  ace: 'CONSENT_MODE_ACE',
  external: 'CONSENT_MODE_EXTERNAL',
};

/**
 * This is the default for roost protobuf enum and existing live pipelines will
 * have CONSENT_MODE_UNSPECIFIED until they are updated.
 *
 * It is treated the same as being in CONSENT_MODE_ACE.
 *
 * It's also not part of CONSENT_MODES above since it will not be an option on the ion side.
 *
 * @type {string}
 */
export const CONSENT_MODE_UNSPECIFIED = 'CONSENT_MODE_UNSPECIFIED';
